import { useEffect, useState } from "react";
import { SIGN_IN_URL, SIGN_UP_URL } from "../lib/site";
import { Wordmark } from "./Mark";

const LINKS = [
	{ href: "#links", label: "How it works" },
	{ href: "#claude", label: "Claude" },
	{ href: "#scenarios", label: "Scenarios" },
	{ href: "#pricing", label: "Pricing" },
];

export function Nav() {
	const [scrolled, setScrolled] = useState(false);
	useEffect(() => {
		const on = () => setScrolled(window.scrollY > 8);
		on();
		window.addEventListener("scroll", on, { passive: true });
		return () => window.removeEventListener("scroll", on);
	}, []);
	return (
		<header
			className={`sticky top-0 z-50 border-b backdrop-blur-md transition-colors duration-200 ${scrolled ? "border-line bg-paper/90" : "border-transparent bg-paper/0"}`}
		>
			<nav className="mx-auto flex h-16 max-w-[1240px] items-center gap-8 px-5 md:px-8" aria-label="Main">
				<a href="#top" className="text-ink" aria-label="ModelCurve, back to the top">
					<Wordmark />
				</a>
				<ul className="hidden items-center gap-7 text-sm text-eggplant md:flex">
					{LINKS.map((l) => (
						<li key={l.href}>
							<a href={l.href} className="hover:text-ink">
								{l.label}
							</a>
						</li>
					))}
				</ul>
				<div className="ml-auto flex items-center gap-2 sm:gap-3">
					<a href={SIGN_IN_URL} className="hidden px-2 text-sm text-eggplant hover:text-ink sm:inline">
						Sign in
					</a>
					<a href={SIGN_UP_URL} className="btn btn-primary !min-h-[38px] !px-3.5">
						Start free
					</a>
				</div>
			</nav>
		</header>
	);
}
